(() => {
  const header=document.querySelector('.om-home .om-header');
  if(!header)return;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let canvas,raf=0,done=false,watchdog;
  const finish=()=>{
    done=true;cancelAnimationFrame(raf);clearTimeout(watchdog);
    canvas?.remove();document.documentElement.classList.remove('om-reveal-pending');
    clearTimeout(window.orbitRevealFallback);
  };
  if(reduced.matches){finish();return;}
  const smooth=n=>{const t=Math.max(0,Math.min(1,n));return t*t*(3-2*t);};
  const glide=n=>{const t=Math.max(0,Math.min(1,n));return t*t*t*(t*(t*6-15)+10);};
  const roundedRoute=(points,radius)=>{
    const clean=points.filter((p,i)=>!i||Math.hypot(p[0]-points[i-1][0],p[1]-points[i-1][1])>.001);
    if(clean.length<2)return [];
    const path=[clean[0]];
    for(let i=1;i<clean.length-1;i++){
      const a=clean[i-1],b=clean[i],c=clean[i+1];
      const incoming=Math.hypot(b[0]-a[0],b[1]-a[1]),outgoing=Math.hypot(c[0]-b[0],c[1]-b[1]);
      const r=Math.min(radius,incoming*.4,outgoing*.4);
      const entry=[b[0]+(a[0]-b[0])*r/incoming,b[1]+(a[1]-b[1])*r/incoming];
      const exit=[b[0]+(c[0]-b[0])*r/outgoing,b[1]+(c[1]-b[1])*r/outgoing];
      path.push(entry);
      for(let j=1;j<=8;j++){const t=j/8,u=1-t;path.push([u*u*entry[0]+2*u*t*b[0]+t*t*exit[0],u*u*entry[1]+2*u*t*b[1]+t*t*exit[1]]);}
    }
    path.push(clean[clean.length-1]);
    return path.slice(1).map((b,i)=>({a:path[i],b,length:Math.hypot(b[0]-path[i][0],b[1]-path[i][1])}));
  };
  const hash=n=>{const v=Math.sin(n*127.1+311.7)*43758.5453;return v-Math.floor(v);};
  const start=async()=>{
    if(document.readyState==='loading')await new Promise(resolve=>document.addEventListener('DOMContentLoaded',resolve,{once:true}));
    await document.fonts.ready;
    if(done)return;
    const box=header.getBoundingClientRect(),w=box.width,h=box.height;
    if(w<40||h<40){finish();return;}
    const dpr=Math.min(Math.max(devicePixelRatio||1,2),3);
    const mask=document.createElement('canvas');mask.width=Math.ceil(w*dpr);mask.height=Math.ceil(h*dpr);
    const ink=mask.getContext('2d');if(!ink){finish();return;}
    ink.scale(dpr,dpr);ink.fillStyle=getComputedStyle(header.closest('.om')).color;ink.textBaseline='alphabetic';
    for(const target of header.querySelectorAll('.om-logo')){
      const style=getComputedStyle(target);
      ink.font=`${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;ink.letterSpacing=style.letterSpacing;
      const runs=target.matches('.om-clock')?[...target.querySelector('[data-om-clock-value]').children]:[target];
      for(const run of runs){
        const text=run.textContent;
        const marker=document.createElement('i');marker.setAttribute('aria-hidden','true');
        marker.style.cssText='display:inline-block;width:0;height:0;padding:0;margin:0;border:0;vertical-align:baseline';
        run.append(marker);const baseline=marker.getBoundingClientRect().top-box.top;marker.remove();
        ink.fillText(text,run.getBoundingClientRect().left-box.left,baseline);
      }
    }
    const pixels=ink.getImageData(0,0,mask.width,mask.height).data;
    const columns=Math.ceil(Math.sqrt((w<700?1500:3200)*w/h)),rows=Math.ceil((w<700?1500:3200)/columns);
    const dx=(w-12)/(columns-1),dy=(h-12)/(rows-1);
    const tiles=[];
    const sx=Math.round(1.8*dpr)/dpr,sy=sx;
    const fineCols=Math.ceil(w/sx),fineRows=Math.ceil(h/sy);
    for(let row=0;row<fineRows;row++)for(let col=0;col<fineCols;col++){
      const x=col*sx,y=row*sy,right=Math.min(w,x+sx),bottom=Math.min(h,y+sy);
      let occupied=false,tx=x,ty=y,bestAlpha=0;
      for(let py=Math.floor(y*dpr);py<Math.ceil(bottom*dpr);py++)for(let px=Math.floor(x*dpr);px<Math.ceil(right*dpr);px++){const alpha=pixels[(py*mask.width+px)*4+3];if(alpha>bestAlpha){bestAlpha=alpha;occupied=true;tx=(px+.5)/dpr;ty=(py+.5)/dpr;}}
      if(!occupied)continue;
      const seed=row*fineCols+col,side=Math.floor(hash(seed+5)*4);
      const gx=6+Math.max(0,Math.min(columns-1,Math.round((x-6)/dx)))*dx;
      const gy=6+Math.max(0,Math.min(rows-1,Math.round((y-6)/dy)))*dy;
      const reach=3+Math.floor(hash(seed+7)*10);
      const originRoll=hash(seed+211);
      const fromCenter=originRoll<.0372;
      const fromUpper=originRoll>=.04&&originRoll<.05395;
      const fromLower=originRoll>=.055&&originRoll<.06895;
      const fromFarRight=originRoll>=.07&&originRoll<.085;
      const fromMiddle=fromCenter||fromUpper||fromLower||fromFarRight;
      const farRightX=6+Math.round((columns-1)*(.70+hash(seed+263)*.03))*dx;
      const farRightY=6+Math.round((rows-1)*(.15+hash(seed+269)*.7))*dy;
      const upperRow=Math.min(rows-1,Math.max(0,Math.round((rows-1)*.08)-1)+Math.floor(hash(seed+239)*3));
      const lowerStart=Math.max(0,Math.min(rows-3,Math.round((rows-1)*.9)-1));
      const lowerRow=lowerStart+Math.floor(hash(seed+251)*3);
      const centerX=6+Math.round((columns-1)*(.46+hash(seed+223)*.08))*dx;
      const centerY=6+Math.round((rows-1)*(.35+hash(seed+227)*.3))*dy;
      const ox=fromFarRight?farRightX:fromMiddle?centerX:side<2?Math.max(6,Math.min(w-6,gx+(side===0?-1:1)*reach*dx)):gx;
      const oy=fromFarRight?farRightY:fromUpper?6+upperRow*dy:fromLower?6+lowerRow*dy:fromCenter?centerY:side>=2?Math.max(6,Math.min(h-6,gy+(side===2?-1:1)*reach*dy)):gy;
      const approachX=fromMiddle?Math.max(Math.min(ox,tx),Math.min(Math.max(ox,tx),gx)):gx;
      const points=fromMiddle?[[ox,oy],[approachX,oy],[approachX,ty],[tx,ty]]:[[ox,oy],[gx,gy],[tx,gy],[tx,ty]];
      const segments=roundedRoute(points,Math.min(2.5,dx*.3,dy*.3));
      const distance=segments.reduce((sum,segment)=>sum+segment.length,0);
      const duration=Math.min(1.25,.55+distance/850+hash(seed+31)*.15);
      const arrival=Math.max(duration+.08,.75+hash(seed+21)*2.5);
      tiles.push({x,y,tx,ty,fromMiddle,width:right-x,height:bottom-y,segments,distance,duration,start:arrival-duration,arrival,landed:false});
    }
    const built=document.createElement('canvas');built.width=mask.width;built.height=mask.height;
    const builtInk=built.getContext('2d');if(!builtInk){finish();return;}builtInk.scale(dpr,dpr);
    canvas=document.createElement('canvas');canvas.width=mask.width;canvas.height=mask.height;canvas.setAttribute('aria-hidden','true');canvas.dataset.orbitGridBuild='';
    canvas.style.cssText=`position:absolute;inset:0;width:${w}px;height:${h}px;pointer-events:none;z-index:2`;
    const ctx=canvas.getContext('2d');if(!ctx){finish();return;}ctx.scale(dpr,dpr);header.append(canvas);
    clearTimeout(window.orbitRevealFallback);watchdog=setTimeout(finish,6000);
    tiles.sort((a,b)=>a.start-b.start);
    let cursor=0;
    const active=new Set();
    let began;
    const frame=now=>{
      if(done)return;
      if(began===undefined)began=now;
      const t=(now-began)/1000;
      if(t>=3.65||document.hidden||reduced.matches){finish();return;}
      ctx.clearRect(0,0,w,h);
      while(cursor<tiles.length&&tiles[cursor].start<=t)active.add(tiles[cursor++]);
      for(const p of active){
        if(t>=p.arrival+(p.fromMiddle?0:.16)){
          builtInk.drawImage(mask,p.x*dpr,p.y*dpr,p.width*dpr,p.height*dpr,p.x,p.y,p.width,p.height);
          active.delete(p);
        }
      }
      ctx.drawImage(built,0,0,w,h);
      ctx.fillStyle='rgba(25,25,25,.5)';
      ctx.beginPath();
      for(const p of active){
        if(t>=p.arrival){
          const amount=smooth((t-p.arrival)/.16);
          const size=p.height*amount;
          if(size>0)ctx.drawImage(mask,p.x*dpr,p.y*dpr,p.width*dpr,size*dpr,p.x,p.y,p.width,size);
          continue;
        }
        let travel=glide((t-p.start)/p.duration)*p.distance;
        let x=p.tx,y=p.ty;
        for(const segment of p.segments){
          if(travel<=segment.length&&segment.length>0){
            const progress=travel/segment.length;
            x=segment.a[0]+(segment.b[0]-segment.a[0])*progress;
            y=segment.a[1]+(segment.b[1]-segment.a[1])*progress;break;
          }
          travel-=segment.length;
        }
        ctx.rect(x-.8,y-.8,1.6,1.6);
      }
      ctx.fill();
      raf=requestAnimationFrame(frame);
    };
    raf=requestAnimationFrame(frame);
    const onResize=()=>{const next=header.getBoundingClientRect();if(Math.abs(next.width-w)>1||Math.abs(next.height-h)>1)finish();};
    window.addEventListener('resize',onResize,{passive:true});
    setTimeout(()=>window.removeEventListener('resize',onResize),6500);
  };
  reduced.addEventListener('change',finish,{once:true});
  window.addEventListener('pagehide',finish,{once:true});
  start().catch(finish);
})();
